import { makeStyles } from "@material-ui/core/styles";
import { deepOrange } from "@material-ui/core/colors";

const UseStyles = makeStyles((theme) => ({
	small_avatar: {
		color: theme.palette.getContrastText(deepOrange[500]),
		backgroundColor: deepOrange[500],
		width: theme.spacing(3),
		height: theme.spacing(3),
		fontSize: "1em",
	},
	row_color1: {
		backgroundColor: "FFFFFF",
	},
	row_color2: {
		backgroundColor: "#F5F5F5",
	},
	data_cell: {
		padding: "5px",
	},
	header_cell: {
		padding: "10px",
		fontWeight: "bold",
	},
	input_control: {
		padding: "2px !important",
	},

	pending_rfi: {
		borderTop: "solid 1px gray",
		borderRight: "solid 1px gray",
		borderBottom: "solid 1px gray",
		borderLeft: "solid 24px red",
		marginBottom: 12,
		position: "relative",
	},

	responded_rfi: {
		borderTop: "solid 1px gray",
		borderRight: "solid 1px gray",
		borderBottom: "solid 1px gray",
		borderLeft: "solid 24px #00ace6",
		marginBottom: 12,
		position: "relative",
	},

	resolved_rfi: {
		borderTop: "solid 1px gray",
		borderRight: "solid 1px gray",
		borderBottom: "solid 1px gray",
		borderLeft: "solid 24px green",
		marginBottom: 12,
		position: "relative",
	},

	corner_text: {
		transform: "rotate(-90deg)",
		position: "absolute",
		top: "50%",
		width: 35,
		color: "white",
		left: -29,
		fontWeight: "bold",
	},
}));

export default UseStyles;
